import React from 'react';
import loadable from 'react-loadable';

const EmptyLoader = () => null;

export const LoadableAccountSettingsV2Root = loadable({
    loader: () => import(/* webpackChunkName: "account-settings-v2" */ './AccountSettingsV2Root'),
    loading: EmptyLoader,
});
